import { GET } from '@/api';

const URL = '/faq/search';

export default async ({ term, from = 0, config, successCB, failCB }) => {
  try {
    const { data } = await GET(`${URL}?q=${term}&from=${from}`, config);
    return (typeof successCB === 'function' && successCB(data)) || data;
  } catch (e) {
    return (typeof failCB === 'function' && failCB(e)) || e;
  }
};
